import type { Router } from 'vue-router';
import { START_LOCATION } from 'vue-router';

const CHUNK_LOAD_ERROR_PATTERNS: ReadonlyArray<RegExp> = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS/i,
];
const RELOAD_GUARD_KEY = 'chunk-load-reload';
const RELOAD_GUARD_WINDOW_MS = 10_000;

type Navigate = (href: string) => void;

export const isChunkLoadError = (error: Error): boolean =>
  error instanceof Error && CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(error.message));

const wasReloadedRecently = (href: string, now: number): boolean => {
  const saved = sessionStorage.getItem(RELOAD_GUARD_KEY);
  if (!saved) {
    return false;
  }
  const separator = saved.indexOf(' ');
  const savedAt = Number(saved.slice(0, separator));
  return saved.slice(separator + 1) === href && now - savedAt < RELOAD_GUARD_WINDOW_MS;
};

const defaultNavigate: Navigate = (href) => {
  window.location.assign(href);
};

export const installChunkLoadRecovery = (router: Router, navigate: Navigate = defaultNavigate): void => {
  router.onError((error: Error, to, from) => {
    if (!isChunkLoadError(error) || from === START_LOCATION) {
      return;
    }
    const href = router.resolve(to.fullPath).href;
    const now = Date.now();
    if (wasReloadedRecently(href, now)) {
      return;
    }
    sessionStorage.setItem(RELOAD_GUARD_KEY, `${now} ${href}`);
    navigate(href);
  });
};
